import { useMutation } from '@tanstack/react-query';
import { axiosApi } from '@utils/fetch';
import { auth, config } from '../config';
import { v4 } from 'uuid';
import { AxiosRequestConfig } from 'axios';
import { ApiLogger, logUserEvent } from 'fmc-digital-common';
import { logApiEvent } from '@analytics/amplifyLogging';
import { useCallback } from 'react';
import { EventType } from 'shared-ui-components';

/*
    13 Sep 2024
    This mutation sends the abandoned lead information for the FullApp to the SF
*/

export const useAbandonedScreenMutation = (appId: string) => {
    const apiEvent = useCallback((event: EventType) => {
        logApiEvent({
            apiName: event.apiName,
            action: event.action,
            correlationId: event.correlationId,
            timestamp: event.timestamp,
            loanNumber: event.loanNumber,
            description: event.description,
            type: 'DigiApp'
        });
    }, []);
    return useMutation({
        // eslint-disable-next-line @typescript-eslint/ban-types
        mutationFn: (requestBody: Object) => {
            const apiParams: AxiosRequestConfig = {
                method: 'PUT',
                url: `${config.env('prefillUrl')}/abandonedScreen/${appId}`,
                headers: {
                    'x-correlation-id': v4().toString(),
                    Authorization: `Bearer ${auth.getOkta().getAccessToken()}`,
                    'x-api-key': config.env('xApiKey'),
                    source: 'DigiApp'
                },
                data: JSON.stringify(requestBody)
            };
            return ApiLogger(apiParams, apiEvent);
        }
    });
};
